<template>
  <div :style="themeColor" class="sub-heading items">
    <div class="clearfix">
        <div class="left">
            <p class="text-large amount">
              {{total}}
            </p>
            <p class="text-large package-name">
              {{item.name}}
            </p>
        </div>
        <div class="right">
            <div class="relative">
              <select class="quantity" id="quantity" v-model.number="item.quantity" >
                  <option v-for="qty in 10" :value="qty"> {{ displayQty(qty) }}</option>
              </select>
              <!-- <label for="quantity"></label> -->
            </div>
            <a href="#" class="remove-item" @click="remove(item)" v-if="item.isAddon"></a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'line-item-multiple',
  props: {
    item: {}
  },
  computed: {
    total() {
      return this.item && this.item.displayTotal();
    },

  },
  methods: {
    displayQty(qty) {
      return "Qty " + qty;
    },
    remove(item) {
      this.$emit("remove", item);
    }
  }
}
</script>


// WEBPACK FOOTER //
// MultipleLineItem.vue?5a51bd34